import { useEffect, useRef, useState } from "react";
import styles from "./category.module.css";
import { IoChevronDown } from "react-icons/io5";
import { HeadingTitle } from "../../../shared/index";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const CategoryFilter = ({ categories = [], heading, filtersActions }) => {
  const { setSelectedCategory, setSelectedSubCategory, setSelectedChildCategory } = filtersActions;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const activeCategory = searchParams.get("category");
  const activeSubCategory = searchParams.get("subcategory");
  const activeChildCategory = searchParams.get("childcategory");

  const [expanded, setExpanded] = useState({});
  const hasInitialized = useRef(false);

  /** ----------------------------------
   * URL → STATE (FIRST LOAD ONLY)
   * ---------------------------------- */
  useEffect(() => {
    if (hasInitialized.current) return;

    if (activeCategory) {
      setSelectedCategory(activeCategory);
      setExpanded((prev) => ({
        ...prev,
        [activeCategory]: true,
      }));
    }

    if (activeSubCategory) {
      setSelectedSubCategory(activeSubCategory);
      setExpanded((prev) => ({
        ...prev,
        [activeSubCategory]: true,
      }));
    }

    if (activeChildCategory) {
      setSelectedChildCategory(activeChildCategory);
    }

    hasInitialized.current = true;
  }, []);

  /** ---------------------------------- */
  const slugify = (str) => str?.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-");

  const buildUrl = (params = {}) => {
    const sp = new URLSearchParams(location.search);

    sp.delete("category");
    sp.delete("subcategory");
    sp.delete("childcategory");

    Object.entries(params).forEach(([k, v]) => {
      if (v) sp.set(k, v);
    });

    return `/shop?${sp.toString()}`;
  };

  /** ---------------------------------- */
  return (
    <>
      <HeadingTitle text={heading || ""} style={styles.sectionTitle} />

      <div className={styles.categoriesList}>
        {categories.map((cat) => {
          const catSlug = cat?.slug || slugify(cat?.name);
          const isOpen = !!expanded[catSlug];
  console.log("CATEGORY:", {
    name: cat?.name,
    slug: cat?.slug,
    generatedSlug: catSlug,
    subcategories: cat?.subcategories,
  });
          return (
            <div key={cat?.id} className={styles.categoryItem}>
              {/* CATEGORY */}
              <button
                className={`${styles.categoryButton} ${
  activeCategory === catSlug ? styles.active : ""
}`}
                onClick={() => {
                  setExpanded((prev) => {
                    const next = !prev[catSlug];
                    if (next) {
                      navigate(buildUrl({ category: catSlug }), { replace: true });
                    }
                    return { ...prev, [catSlug]: next };
                  });
                }}
              >
                <span  className={styles.catnam}>{cat.name}</span>
{cat.subcategories?.length > 0 && (
  <IoChevronDown
    className={`${styles.chevronIcon} ${
      isOpen ? styles.rotate : ""
    }`}
  />
)}
              </button>

              {/* SUBCATEGORIES */}
              {cat.subcategories?.length > 0 && isOpen && (
                <div className={styles.subListOpen}>
                  {cat.subcategories.map((sub) => {
                    const subSlug = sub?.slug || slugify(sub?.name);
                    const isSubOpen = !!expanded[subSlug];

                    return (
                      <div key={sub?.id}>
                        {/* SUBCATEGORY */}
                        <button
                         className={`${styles.subItem} ${
  activeSubCategory === subSlug ? styles.subActive : ""
}`}
                          onClick={() => {
                            setExpanded((prev) => {
                              const next = !prev[subSlug];
                              if (next) {
                                navigate(buildUrl({ category: catSlug, subcategory: subSlug }), { replace: true });
                              }
                              return { ...prev, [subSlug]: next };
                            });
                          }}
                        >
                          {sub.name}
                      {sub.child_categories?.length > 0 && (
  <IoChevronDown
    className={`${styles.chevronIcon} ${
      isSubOpen ? styles.rotate : ""
    }`}
  />
)}
                        </button>

                        {/* CHILD CATEGORIES */}
                        {sub.child_categories?.length > 0 && isSubOpen && (
                          <div style={{ paddingLeft: "1rem" }}>
                            {sub.child_categories.map((child) => {
                              const childSlug = child?.slug || slugify(child?.name);
                              console.log("CHILD CATEGORY:", {
    parentCategory: cat?.name,
    subcategory: sub?.name,
    childName: child?.name,
    childId: child?.id,
    childSlug: child?.slug,
    generatedChildSlug: childSlug,
    childObject: child,
  });
                              return (
                                <div key={child?.id}>
                               
<a
  href={buildUrl({
    category: catSlug,
    subcategory: subSlug,
    childcategory: childSlug,
  })}
  className={`${styles.subItem} ${
    activeChildCategory === childSlug ? styles.subActive : ""
  }`}
  onClick={(e) => {
    e.preventDefault();

    setSelectedCategory(catSlug);
    setSelectedSubCategory(subSlug);
    setSelectedChildCategory(childSlug);

    setExpanded((prev) => ({
      ...prev,
      [catSlug]: true,
      [subSlug]: true,
    }));

    navigate(
      buildUrl({
        category: catSlug,
        subcategory: subSlug,
        childcategory: childSlug,
      }),
      { replace: true }
    );
  }}
>
  {child.name}
</a>

                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CategoryFilter;